import { useUserProfileContext, UserProfile } from '@/contexts/UserProfileContext';

// ============================================
// 🚀 SIMPLIFICADO: Usa contexto centralizado
// Não faz mais query própria - compartilha cache
// ============================================

export type { UserProfile };

export function useUserProfile() {
  const ctx = useUserProfileContext();
  
  return {
    data: ctx.profile,
    isLoading: ctx.isLoadingProfile,
    error: null,
  };
}
